;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { CONTRACTOR_ROLE_VALUES, TEAM_ROLES, USER_ROLES } from './constants';
import { getUserFromToken } from './permissions';

const TEAM_ROLE_VALUES = new Set(Object.values(TEAM_ROLES));
const CONTRACTOR_ROLE_VALUE_SET = new Set<string>(CONTRACTOR_ROLE_VALUES);

export function isContractorRole(role: string | undefined | null): boolean {
  return role != null && CONTRACTOR_ROLE_VALUE_SET.has(role);
}

export function rolesIncludeContractor(roles?: readonly string[] | null): boolean {
  return (roles ?? []).some(isContractorRole);
}

export function isIndividualContractorLikeRole(role: string): boolean {
  return role === USER_ROLES.INDIVIDUAL_CONTRACTOR || role === USER_ROLES.CONTRACTOR_OF_RECORD;
}

export function filterOutTeamRoles(roles: string[]): string[] {
  return roles.filter((role) => !TEAM_ROLE_VALUES.has(role));
}

export async function hasRole(roleName: string): Promise<boolean> {
  try {
    const user = await getUserFromToken();

    if (!user?.roles) {
      return false;
    }

    return user.roles.includes(roleName);
  } catch (error) {
    console.error('Error checking role:', error);
    return false;
  }
}

export async function hasAnyRole(roleNames: string[]): Promise<boolean> {
  try {
    const user = await getUserFromToken();

    if (!user?.roles) {
      return false;
    }

    return roleNames.some((roleName) => user.roles.includes(roleName));
  } catch (error) {
    console.error('Error checking roles:', error);
    return false;
  }
}

export async function hasAllRoles(roleNames: string[]): Promise<boolean> {
  try {
    const user = await getUserFromToken();

    if (!user?.roles) {
      return false;
    }

    return roleNames.every((roleName) => user.roles.includes(roleName));
  } catch (error) {
    console.error('Error checking roles:', error);
    return false;
  }
}

export async function getUserRoles(): Promise<string[]> {
  try {
    const user = await getUserFromToken();
    return user?.roles || [];
  } catch (error) {
    console.error('Error getting user roles:', error);
    return [];
  }
}

export interface AuthTeamMembership {
  team_id: number;
  team_role?: string[];
}

/** Team IDs where the user has the team lead role (all teams, not only the first). */
export function getTeamLeadTeamIdsFromTeams(teams?: AuthTeamMembership[] | null): number[] {
  return (teams ?? [])
    .filter((team) => (team.team_role ?? []).includes(TEAM_ROLES.TEAM_LEAD))
    .map((team) => team.team_id);
}

export async function hasTeamRole(roleName: string): Promise<boolean> {
  try {
    const user = await getUserFromToken();
    return (user?.teams ?? []).some((team) => (team.team_role ?? []).includes(roleName));
  } catch (error) {
    console.error('Error checking team role:', error);
    return false;
  }
}

export async function getTeamLeadTeamIds(): Promise<number[]> {
  try {
    const user = await getUserFromToken();
    return getTeamLeadTeamIdsFromTeams(user?.teams);
  } catch (error) {
    console.error('Error getting team lead team ids:', error);
    return [];
  }
}

export async function getTeamLeadId(): Promise<number | undefined> {
  const teamLeadTeamIds = await getTeamLeadTeamIds();
  return teamLeadTeamIds[0];
}
